import styles from "./fade-in-text-effect.module.css";
import Text from "../text/text";
import { ReactNode, useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)

export interface FadeInTextEffectProps {
  children: ReactNode;
  containerAnimation?: gsap.core.Animation;
  figmaStyle:string
}
function FadeInTextEffect(props: FadeInTextEffectProps) {
  const renderElementRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const ctx = gsap.context(() => {
      ScrollTrigger.matchMedia({
        "(min-width: 1024px)": function () {
          const tl = gsap.timeline({
            scrollTrigger: {
              start: "left 80%",
              trigger: renderElementRef.current,
              containerAnimation: props.containerAnimation,
            },
          });
          tl.from(
            renderElementRef.current?.querySelectorAll(
              "strong > strong"
            ) as NodeListOf<HTMLElement>,
            1.4,
            {
              y: 180,
              ease: "power4.out",
              delay: 0,
              skewY: 10,
              stagger: {
                amount: 0.2,
              },
            }
          );
        },
        "(max-width: 1023px)": function () {
            const tl = gsap.timeline({
              scrollTrigger: {
                start: "top bottom",
                trigger: renderElementRef.current,
              },
            });
            tl.from(
              renderElementRef.current?.querySelectorAll(
                "strong > strong"
              ) as NodeListOf<HTMLElement>,
              1.4,
              {
                y: 160,
                ease: "power4.out",
                delay: 0,
                skewY: 10,
                stagger: {
                  amount: 0.2,
                },
              }
            );
          },
        
      });
    });

    return () => ctx.revert();
  }, [props.containerAnimation]);
  return (
    <div className={styles.ctn} style={{
        "--fade-in-text-font-size":`var(--detail-${props.figmaStyle}-font-size)`
    } as React.CSSProperties}>
      <div className={styles.putElement}>{props.children}</div>
      <div className={`${styles.renderElement}`} ref={renderElementRef}>
        {props.children}
      </div>
    </div>
  );
}

export default FadeInTextEffect;
